import Vue from 'vue'
import PinchZoom from 'vue-pinch-zoom'
Vue.component('pinch-zoom', PinchZoom)
